export default {
      
    SET_SELECTED_M0_CHECK_LIST_ID(state, data) {
        state.selectedM0CheckListId = data;
    },
    SET_SELECTED_ROOM_ID(state, data) {
        state.selectedRoomId = data;
    },
    SET_SELECTED_EDIT_HISTORY_ID(state, data) {
        state.selectedEditHistoryId = data;
    },
    SET_ROOM_MASTERS_MAP(state, data) {
        if ( data.length > 0 ) {
            state.roomMastersMap[data[0].version_id] = data;
        }
    },
    SET_ROOM_DATAS(state, data) {
        state.roomDatas = data;
    },
    SET_EDIT_HISTORY_LIST_MAP(state, data) {
        state.editHistoryListMap = data;
    },
    SET_ITEM_VALUE_LIST_HISTORY_MAP_MAP(state, data) {
        state.itemValueListHistoryMapMap = data;
    },
    SET_ITEM_FRAME_MAP_MAP(state, data) {
        state.itemFrameMapMap = data;
    },
}
